// extracted by mini-css-extract-plugin
export var carrierTab = "_3y-0";
export var carrierTabActive = "_3y-1 _3y-0";
export var carrierTabInactive = "_3y-2 _3y-0";
export var carrierTabLabel = "_3y-3";
export var carrierTabLabelActive = "_3y-4 _3y-3";
export var carrierTabLabelInactive = "_3y-5 _3y-3";
export var carrierTabPercentage = "_3y-6";
export var carrierTabPercentageActive = "_3y-7 _3y-6";
export var carrierTabPercentageInactive = "_3y-8 _3y-6";
export var carrierTabWinnable = "_3y-9";
export var carrierTabWinnableActive = "_3y-a _3y-9";
export var carrierTabWinnableInactive = "_3y-b _3y-9";
export var comparisonContainer = "_3y-d";
export var missingRateButton = "_3y-n";
export var missingRateButtonActive = "_3y-o _3y-n";
export var missingRateButtonInactive = "_3y-p _3y-n";
export var missingRateButtonLabel = "_3y-q";
export var missingRateButtonLabelActive = "_3y-r _3y-q";
export var missingRateButtonLabelInactive = "_3y-s _3y-q";
export var sidebar = "_3y-c";
export var strategyButton = "_3y-e";
export var strategyButtonActive = "_3y-f _3y-e";
export var strategyButtonDescription = "_3y-k";
export var strategyButtonDescriptionActive = "_3y-l _3y-k";
export var strategyButtonDescriptionInactive = "_3y-m _3y-k";
export var strategyButtonInactive = "_3y-g _3y-e";
export var strategyButtonLabel = "_3y-h";
export var strategyButtonLabelActive = "_3y-i _3y-h";
export var strategyButtonLabelInactive = "_3y-j _3y-h";
export var unitToggleButton = "_3y-t";
export var unitToggleButtonActive = "_3y-u _3y-t";
export var unitToggleButtonInactive = "_3y-v _3y-t";
export var unitToggleButtonLabel = "_3y-w";
export var unitToggleButtonLabelActive = "_3y-x _3y-w";
export var unitToggleButtonLabelInactive = "_3y-y _3y-w";